import { render, staticRenderFns } from "./ColorPie.vue?vue&type=template&id=1c8e9da5"
import script from "./ColorPie.vue?vue&type=script&lang=ts"
export * from "./ColorPie.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports